<div id="app-loading">
  <img alt="loading" class="loading" height="200" ngSrc="../assets/imgs/loading.gif" width="200">
</div>
<router-outlet></router-outlet>
